(function () {
  chooseTimeslotContainer.$inject = ["API_URL", "$rootScope"];
  angular.module('calendarApp').directive('chooseTimeslotContainer', chooseTimeslotContainer);

  function chooseTimeslotContainer(API_URL, $rootScope) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/choose-timeslot-container.html',
      scope: {
        initTimeslots: '='
      },
      link: function link(scope, elem, attrs) {
        scope.initTimeslots = function (shift) {
          scope.shift = shift;
          scope.timeSettings = $rootScope.timeSettings;
          scope.timeslotsAvailable = [];
          scope.chosenTimeslots = [];
          scope.shift.timeslots.forEach(function (timeslot) {
            var slot = {
              date: moment.unix(timeslot.start).format('ddd ll'),
              start: timeslot.start,
              end: timeslot.end + 1,
              service: shift.serviceName,
              resource: shift.hasresource ? shift.resource.name : null
            };
            scope.timeslotsAvailable.push(slot);
          });
        };

        scope.addTimeslot = function (index) {
          scope.chosenTimeslots.push(scope.timeslotsAvailable[index]);
          scope.timeslotsAvailable.splice(index, 1);
        };

        scope.removeTimeslot = function (index) {
          scope.timeslotsAvailable.push(scope.chosenTimeslots[index]);
          scope.chosenTimeslots.splice(index, 1);
        };
      }
    };
  }
})();